import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import appReducer from './reducers/app.reducer'
import addonsReducer from './reducers/addons.reducer'
import userReducer from './reducers/user.reducer'
import adminReducer from './reducers/admin.reducer'
import usersReducer from './reducers/users.reducer'
import accountReducer from './reducers/account.reducer'
import domainsListReducer from './reducers/domainsList.reducer'
import domainsDataReducer from './reducers/domainsData.reducer'
import reportsReducer from './reducers/reports.reducer'
import keywordsReducer from './reducers/keywords.reducer'
import competitorsData from './reducers/competitors.reducer'
import seoChecklistReducer from './reducers/seoChecklist.reducer'
import notificationReducer from './reducers/notification.reducer'
import keywordFinderReducer from './reducers/keywordFinder.reducer'
import serpCheckerReducer from './reducers/serpChecker.reducer'
import websiteAuditReducer from './reducers/websiteAudit.reducer'
import billingReducer from './reducers/billing.reducer'
import dashboardReducer from './reducers/dashboard.reducer'
import listReducer from './reducers/list.reducer'
import pagesReducer from './reducers/pages.reducer'
import appUsageReducer from './reducers/appUsage.reducer'
import filtersReducer from './reducers/filters.reducer'
import selectionReducer from './reducers/selection.reducer'
import tourReducer from './reducers/tour.reducer'
import backlinkCheckerReducer from './reducers/backlinkChecker.reducer'
import favouriteLinksReducer from './reducers/favouriteLinks.reducer'
import searchReducer from './reducers/search.reducer'
import localesReducer from './reducers/locales.reducer'
import statusReducer from './reducers/status.reducer'
import errorReducer from './reducers/error.reducer'

const MainReducer = history =>
  combineReducers({
    router: connectRouter(history),
    app: appReducer,
    addons: addonsReducer,
    user: userReducer,
    admin: adminReducer,
    users: usersReducer,
    account: accountReducer,
    billing: billingReducer,
    domainsList: domainsListReducer,
    domainsData: domainsDataReducer,
    keywordsData: keywordsReducer,
    competitorsData: competitorsData,
    reports: reportsReducer,
    checklist: seoChecklistReducer,
    notification: notificationReducer,
    keywordFinder: keywordFinderReducer,
    serpChecker: serpCheckerReducer,
    websiteAudit: websiteAuditReducer,
    dashboard: dashboardReducer,
    listData: listReducer,
    pages: pagesReducer,
    appUsage: appUsageReducer,
    filters: filtersReducer,
    selection: selectionReducer,
    tour: tourReducer,
    backlinkChecker: backlinkCheckerReducer,
    favouriteLinks: favouriteLinksReducer,
    search: searchReducer,
    locales: localesReducer,
    status: statusReducer,
    error: errorReducer
  })

export default MainReducer
